import { addBook } from "../actions";

const adder = (item) => {
  return async (dispatch) => {
    const response = await fetch("http://localhost:9000/books", {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      body: JSON.stringify(item),
    });
    const book = await response.json();

    dispatch(addBook(book));
  };
};

export default adder;
